import { metroGeographyBranchLabels } from '../constants/branch-labels';
import { defineTreeFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const hqLocationDescriptor = defineTreeFilter({
  definition: {
    id: FilterId.HQ_LOCATION,
    name: 'HQ Location',
    selectionListIds: ['region', 'country', 'msa'],
    selections: [],
    branches: metroGeographyBranchLabels,
    type: FilterType.TREE,
    isVisible: true,
  },
});
